import { Button as MaterialButton } from '@mui/material';
import { memo } from 'react';

import { formatCreditsText, roundOffCredits } from '@/utils';

import CreditsButton from '../CreditsButton';
import s from './Actions.module.scss';

interface ActionsProps {
  bookingFee: number;
  expertCredits: number;
  submitting: boolean;
  disabled?: boolean;
  onCancel: () => void;
}

function Actions({
  bookingFee,
  expertCredits,
  submitting,
  disabled = false,
  onCancel,
}: ActionsProps) {
  const credits = roundOffCredits(expertCredits);

  return (
    <div className={s.root}>
      <div>
        <MaterialButton onClick={onCancel}>Cancel</MaterialButton>
      </div>
      <CreditsButton
        credits={credits + bookingFee}
        disabled={submitting || disabled}
        type="submit"
        creditsTooltip={
          <div>
            {credits > 0 && <div>Expert time: {formatCreditsText(credits)}</div>}
            <div>Booking fee: {formatCreditsText(bookingFee)}</div>
          </div>
        }
      >
        {submitting ? 'Submitting...' : 'Submit Request'}
      </CreditsButton>
    </div>
  );
}

export default memo(Actions);
